import { render, staticRenderFns } from "./home.vue?vue&type=template&id=8c6dc12e&scoped=true&lang=pug&"
import script from "./home.vue?vue&type=script&lang=js&"
export * from "./home.vue?vue&type=script&lang=js&"
import style0 from "./home.vue?vue&type=style&index=0&id=8c6dc12e&prod&lang=sass&scoped=true&"
import style1 from "./home.vue?vue&type=style&index=1&id=8c6dc12e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6dc12e",
  null
  
)

export default component.exports